import React from 'react'

const ReturnManagement = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={40}
                height={40}
                x={0}
                y={0}
                viewBox="0 0 512 512"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className="hovered-paths"
            >
                <g>
                    <path
                        fill="#f16932"
                        d="M105.7 233.9v155.6l135.1 78 1.1-.6V310.5z"
                        opacity={1}
                        data-original="#f16932"
                    />
                    <path
                        fill="#f88d28"
                        d="M241.9 310.5v156.4l134-77.4V233.9z"
                        opacity={1}
                        data-original="#f88d28"
                    />
                    <path
                        fill="#fec233"
                        d="M375.9 233.6v.4l-134 76.5c-40.2-22.6-95.9-54-136.1-76.6v-.3l135.1-78c39.8 23.1 95.1 54.9 135 78z"
                        opacity={1}
                        data-original="#fec233"
                        className="hovered-path"
                    />
                    <path
                        fill="#6a478d"
                        d="m192.4 282.6-.3.2v47.1l-36.6-20.5v-47.5z"
                        opacity={1}
                        data-original="#6a478d"
                    />
                    <path
                        fill="#806cb6"
                        d="m327.4 205.6-9.5 5.2-125.5 71.8-36.9-20.7v-.3l135-77.3z"
                        opacity={1}
                        data-original="#806cb6"
                    />
                    <path
                        fill="#ff80b4"
                        d="M474.2 220.1c-24-99.4-117-172.4-218.2-178.3V1c-26.2 16.9-78.8 51-104.9 67.9 26.2 16.9 78.8 51 104.9 67.9V99.5c0-4.2 61.1 11.1 67.8 13.9 115.3 46.3 152.6 201.2 76.4 297.9-52.2 68.2-145.9 93-226.3 64.7C59.2 437 2 300.3 54.8 191.1c-82.3 153 52.6 339 222.7 318.3 139.6-14.5 232.8-155.5 196.7-289.3z"
                        opacity={1}
                        data-original="#ff80b4"
                    />
                </g>
            </svg>

        </>
    )
}

export default ReturnManagement